module.exports = __webpack_public_path__ + "static/media/postit-activity.67aef732.JPG";